import { logE } from "@blacknut/logging/dist";
import { getLinkedAccounts } from "core";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { LOGGING_TAG } from "./Utils";
import { unstable_batchedUpdates } from "react-dom";
import { LinkedAccount } from "@blacknut/javascript-sdk/dist";

export const useLinkedAccounts = () => {
  const dispatch = useDispatch();
  const [pending, setPending] = useState(true);
  const mounted = useRef(false);
  const [accounts, setLinkedAccounts] = useState<LinkedAccount[]>([]);

  useEffect(() => {
    if (mounted.current) return;
    mounted.current = true;

    const init = async () => {
      try {
        const res = await getLinkedAccounts()(dispatch);
        unstable_batchedUpdates(() => {
          setPending(false);
          setLinkedAccounts(res);
        });
      } catch (e) {
        logE(LOGGING_TAG, "Caught error getting linked accounts: %o", e);
      }
    };
    init();
  }, [dispatch]);

  return {
    pending,
    accounts,
  };
};
